module.exports = __webpack_public_path__ + "media/img/private-venue/hover-unique-ae8b814199d5de28c1fd3363794f18f9.svg";